import { render, staticRenderFns } from "./pricenewN.vue?vue&type=template&id=14e5868c&scoped=true"
import script from "./pricenewN.vue?vue&type=script&lang=js"
export * from "./pricenewN.vue?vue&type=script&lang=js"
import style0 from "./pricenewN.vue?vue&type=style&index=0&id=14e5868c&prod&scoped=true&lang=css"
import style1 from "./pricenewN.vue?vue&type=style&index=1&id=14e5868c&prod&lang=css"
import style2 from "./pricenewN.vue?vue&type=style&index=2&id=14e5868c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e5868c",
  null
  
)

export default component.exports